import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-sales-contract',
  templateUrl: './sales-contract.component.html',
  styleUrls: ['./sales-contract.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SalesContractComponent {

}
